/**
 * EmailFillIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const EmailFillIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.383 4.07q.051.016.104.028L12 12.586 3.513 4.098l.105-.028C3.74 4.035 3.865 4 4 4h16c.135 0 .259.035.383.07" />
    <path d="M12 14.586c.535 0 1.038-.208 1.414-.585l8.487-8.49.029.105c.035.124.07.249.07.384v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-.135.035-.259.07-.383l.028-.104 8.487 8.486c.378.38.88.587 1.415.587" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const EmailFillIcon = makeIcon('EmailFillIcon', EmailFillIconSvg)
